import React from 'react';
import CountDownBadge from '../../common/CountDown/CountDownBadge';
import RaceInfoList from './RaceInfoList';
import style from './index.scss';

export const RaceCountDown = ({
    className = '',
    leaderboardEndTime: endTime,
    leaderboardStartTime: startTime,
    status,
    color = 'light'
}) => <CountDownBadge {...{ status, startTime, endTime, color, className }} />;

export default ({ className = '', view = 'column', displayCountdown, ...details }) => (
    <div className={`${style.container} ${style[view]} ${className}`}>
        <RaceInfoList {...details} splitIntoColumns={!displayCountdown && view === 'row'} />
        {displayCountdown && <RaceCountDown className={style.countdown} {...details} />}
    </div>
);
